import { createSlice } from "@reduxjs/toolkit";
import {
  AddSectAction,
  DeleteSectAction,
  GetAllSectAction,
  UpdateSectAction,
} from "store/middlewares/dataManagement/sect";

// isDeleteMeFulFilled
export const sectSlice = createSlice({
  name: "sect",
  initialState: {
    sectLoading: true,
    sect: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllSectAction.pending, (state) => {
        // state.sectLoading = true;
        // state.sect = null;
        state.sect = state.sect?.data?.length > 0 ? state.sect : null;
      })
      .addCase(GetAllSectAction.fulfilled, (state, action) => {
        state.sectLoading = false;
        state.sect = action.payload.response;
      })
      .addCase(GetAllSectAction.rejected, (state) => {
        state.sectLoading = false;
        state.sect = null;
      })
      // Delete
      .addCase(DeleteSectAction.fulfilled, (state, action) => {
        // state.sectLoading = false;
        // state.sect = {
        //   ...state.sect,
        //   total: Number(state.sect.total) - 1,
        //   data: state.sect?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.sectLoading = false;
        state.sect = action.payload.response;
      })
      //Update
      .addCase(UpdateSectAction.fulfilled, (state, action) => {
        state.sectLoading = false;
        state.sect = {
          ...state.sect,
          data: state.sect.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddSectAction.fulfilled, (state, action) => {
        // state.sectLoading = false;
        // state.sect = {
        //   ...state.sect,
        //   total: Number(state.sect.total) + 1,
        //   data: [action.payload.response, ...state.sect.data],
        // };
        state.sectLoading = false;
        state.sect = action.payload.response;
      });
  },
});

export default sectSlice.reducer;
